import { deviceMasterData } from "../actionTypes"

// Merges a patch into the Device Master page state.
export const setDeviceMaster = (data) => {
    return {
        type: deviceMasterData.MERGE,
        payload: data
    }
}
